import privacyRaw from './legal/privacy.txt?raw'
import termsRaw from './legal/terms.txt?raw'

/** Same split as mobile `SignUpConsentContent.parseParagraphs` — drop the title line. */
export function parseLegalDocumentParagraphs(raw: string): string[] {
  const lines = raw
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
  if (lines.length <= 1) return lines
  return lines.slice(1)
}

export const PRIVACY_POLICY_SECTION_TITLE = 'Privacy Policy'
export const TERMS_POLICY_SECTION_TITLE = 'Terms & Conditions'

export const PRIVACY_ACCEPT_LABEL = 'I Accept Privacy Policy'
export const TERMS_ACCEPT_LABEL = 'I Accept Terms & Conditions'

export const PRIVACY_LAST_UPDATED =
  'The Privacy Policy were last updated on August 20, 2026'
export const TERMS_LAST_UPDATED =
  'The Terms and Conditions were last updated on April 28, 2026'

export const PRIVACY_BODY_PARAGRAPHS = parseLegalDocumentParagraphs(privacyRaw)
export const TERMS_BODY_PARAGRAPHS = parseLegalDocumentParagraphs(termsRaw)
